import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Lieferstruktur',
  subtitle: 'Wähle, wie Bestellungen geliefert werden (pro Standort).',
  form: {
    delivery_mode: {
      label: 'Liefermodus',
      placeholder: 'Liefermodus auswählen',
      options: {
        [DeliveryMode.Internal]: 'Intern (eigene Fahrer)',
        [DeliveryMode.External]: 'Extern (Drittanbieter)',
      },
    },
  },
  buttons: {
    back: 'Zurück',
    next: 'Weiter',
    skip: 'Überspringen',
  },
  toasts: {
    error: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
  },
};
